import { IPagedRequest } from "./request.model";

export interface ILogRequest extends IPagedRequest {
  type?: "error" | "warn" | "info" | "debug" | null;
  startDate?: string | null;
  endDate?: string | null;
}

export interface ILogsApiData {
  logs: ILogApiItem[];
  totalCount: number;
  hasMore: boolean;
  currentPage: number;
}

export interface ILogApiItem {
  _id: string;
  message: string;
  timestamp: Date;
  level: "error" | "warn" | "info" | "debug";
  application: string;
  type: string;
  sender: string;
  deletedAt?: string | null;
  metadata?: {
    originalUrl?: string;
    ip?: string;
    xApplicationType?: string;
    userId?: string;
    methodType: string;
    protocol: string;
    status?: number | string;
    params: string | null;
    body: string | null;
    query: string | null;
  };
  selected: boolean;
}

export enum LogLevel {
  Error = "error",
  Warn = "warn",
  Info = "info",
  Debug = "debug",
}
